import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVars } from '../../../providers/globalVars';
import { NavController,IonRouterOutlet } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { AngularFireDatabase, AngularFireList, AngularFireObject } from '@angular/fire/database';
import { map } from 'rxjs/operators';
@Component({
  selector: 'app-recentlist',
  templateUrl: './recentlist.page.html',
  styleUrls: ['./recentlist.page.scss'],
})
export class RecentlistPage implements OnInit {
  templist: any[] = [];
  recentlist:any[] = [];
  msgshowcount: any = 15;
  lastdate: any = null;
  cangoback:boolean = false;
  chkck:any = 0;
  datenow: any = new Date().getTime();
  constructor(public gv: GlobalVars,private outlet: IonRouterOutlet,public navCtrl: NavController,
    public translate: TranslateService,// public navParams:NavParams ,
    private route: ActivatedRoute, public afDB: AngularFireDatabase) {
    
  }

  close() {
   // if (this.cangoback) {
      this.navCtrl.pop();
   // } else
   //   this.navCtrl.navigateBack('/');
  }

  ngOnInit() {
    this.cangoback = this.outlet && this.outlet.canGoBack();
    if(this.gv.param.recentdata)
    {
      this.gv.param.recentdata.map(data=>{
        this.recentlist.push(data);
      })
      this.lastdate = this.recentlist[Object.keys(this.recentlist)[this.recentlist.length-1]].createdDate;
    }
    else
      this.getdata();
  }

  getdata(infi?)
  {
    this.afDB.database.ref(this.gv.getListDir())
    .orderByChild('createdDate').endAt(this.lastdate ? this.lastdate - 1 : 9999999999999)
    .limitToLast(this.msgshowcount).once('value').then(rst => {
        let lastondata;
        this.templist = [];
        rst.forEach(item => {
          let data = item.val();
          if(!lastondata) lastondata = data.createdDate;
          if(!item.val().private)
          this.templist.unshift({
            $key:item.key, createdDate:data.createdDate,title:data.title,
            replycount:data.replycount,type:data.type,
            communityname:data.communityname,
            read:data.read,imagethumb:data.imagethumb
          })
        })
        this.lastdate = lastondata;
        }).then(_ => {
        this.templist.map(data=>{
          this.recentlist.push(data);
        })
        }).then(_ => {
        if (infi)
          infi.target.complete();
      })
  }

  doInfiMsg(infiniteScroll) {
    this.getdata(infiniteScroll);
  }

}
